import React from 'react';
import './Dashboard.css';

const Dashboard = ({ url, title }) => {
  return (
    <div className="iframe-container">
      <iframe
        src={url}
        title={title}
        allowFullScreen
        className="dashboard-iframe"
      />
    </div>
  );
};

export default Dashboard; 